import CreateProduct from "../products/createProduct/createProduct";
import { EXTENDED_ART_KIND } from "./kind";

/** Criação do pedido de arte estendida: o mesmo wizard do pedido comum, sem tipo de graduação (spec §5.2, D8). */
const ExtendedArtCreate = ({ user }) => <CreateProduct user={user} kind={EXTENDED_ART_KIND} />;

export default ExtendedArtCreate;
